import Background360 from 'assets/img/register/register-360w.jpg';
import Background414 from 'assets/img/register/register-414w.jpg';
import Background1366 from 'assets/img/register/register-1366w.jpg';
import Background1440 from 'assets/img/register/register-1440w.jpg';
import Background1920 from 'assets/img/register/register-1920w.jpg';
import Background3840 from 'assets/img/register/register-3840w.jpg';

const backgroundStyle = (theme) => ({
	'@media (max-width: 3840px)': {
		responsiveBackground: {
			backgroundImage: `url(${Background3840})`,
		},
	},
	'@media (max-width: 1920px)': {
		responsiveBackground: {
			backgroundImage: `url(${Background1920})`,
		},
	},
	'@media (max-width: 1440px)': {
		responsiveBackground: {
			backgroundImage: `url(${Background1440})`,
		},
	},
	'@media (max-width: 1366px)': {
		responsiveBackground: {
			backgroundImage: `url(${Background1366})`,
		},
	},
	'@media (max-width: 414px)': {
		responsiveBackground: {
			backgroundImage: `url(${Background414})`,
		},
	},
	'@media (max-width: 360px)': {
		responsiveBackground: {
			backgroundImage: `url(${Background360})`,
		},
	},
	responsiveBackground: {
		backgroundRepeat: 'no-repeat',
		backgroundAttachment: 'fixed',
		backgroundSize: 'cover',
		[theme.browser.IE]: {
			backgroundAttachment: 'inherit!important',
		},
	},
});

export default backgroundStyle;
